<template>
  <v-card flat>
    <v-container>
      <v-form>
        <h3 class="earth-color">Pricing</h3>
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="facility.start_date"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="facility.start_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="facility.start_date"
                  scrollable
                  :min="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    :depressed="true"
                    flat
                    color="primary"
                    @click="modal1 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    :depressed="true"
                    flat
                    color="primary"
                    @click="$refs.dialog.save(facility.start_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog1"
                persistent
                v-model="modal2"
                lazy
                full-width
                width="290px"
                :return-value.sync="facility.end_date"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="facility.end_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="facility.end_date"
                  scrollable
                  :min="facility.start_date"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    :depressed="true"
                    flat
                    color="primary"
                    @click="modal2 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    :depressed="true"
                    flat
                    color="primary"
                    @click="$refs.dialog1.save(facility.end_date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-select
                slot="activator"
                label="Lead Time Format"
                v-model="facility.lead_time_format"
                :items="formatArray"
                :rules="[v => !!v || 'Item is required']"
                required
              ></v-select>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                slot="activator"
                label="Lead Time"
                v-model="facility.lead_time"
                :rules="requiredRules"
                required
                type="number"
              ></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="singleFacility.facility_type_id === 'External Accommodation'"
        >
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Currency"
                v-model="facility.currency_type"
                :items="allCurrencyTypes"
                :rules="[v => !!v || 'Currency is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Parameter"
                v-model="facility.facility_parameter_id"
                :items="facilityPricedParameter"
                :rules="[v => !!v || 'Pricing parameter is required']"
                required
                item-text="facility_parameter_name"
                item-value="public_id"
                @change="getRate"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>

          <v-flex lg3 md3 sm3 xs3>
            <v-container>
              <v-text-field
                type="number"
                label="Amount"
                v-model="facility.mandatory_price"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>

          <v-flex lg9 md9 sm9 xs9>
            <v-container>
              <h5 style="margin-top:25px">{{ rateValue }}</h5>
            </v-container>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="singleFacility.facility_type_id === 'Camping Sites'"
        >
          <v-flex lg3 md3 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Currency"
                v-model="facility.currency_type"
                :items="allCurrencyTypes"
                :rules="[v => !!v || 'Currency is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                type="number"
                label="Adult Price"
                v-model="facility.adult_price"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                type="number"
                label="Child Price"
                v-model="facility.child_price"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                type="number"
                label="Mandatory Price"
                v-model="facility.mandatory_price"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="
            singleFacility.facility_type_id === 'Accomodation' &&
              singleFacility.accomodation_type_id === 'Stables'
          "
        >
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Currency"
                v-model="facility.currency_type"
                :items="allCurrencyTypes"
                :rules="[v => !!v || 'Currency is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                type="number"
                label="Mandatory Price"
                v-model="facility.mandatory_price"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="
            singleFacility.facility_type_id === 'Accomodation' &&
              singleFacility.accomodation_type_id === 'Pelican'
          "
        >
          <v-flex lg4 md4 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Currency"
                v-model="group.currency_type"
                :items="allCurrencyTypes"
                :rules="[v => !!v || 'Currency is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Pricing Type"
                v-model="group.pricing_type"
                :items="cateringType"
                :rules="[v => !!v || 'Pricing Type is required']"
                required
                item-text="facility_pricing_name"
                item-value="facility_pricing_type_public_id"
              ></v-autocomplete>
            </v-container>
          </v-flex>

          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-text-field
                label="Child Price"
                v-model="group.child_price"
                :rules="requiredRules"
                required
                type="number"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                type="number"
                label="From (Number of Guests)"
                v-model="group.price_from"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                type="number"
                label="To (Number of Guests)"
                v-model="group.price_to"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                label="Price p/p"
                v-model="group.price"
                :rules="requiredRules"
                required
                type="number"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container fluid>
              <v-btn
                :depressed="true"
                color="default"
                @click.prevent="addGroup()"
                >Add Price</v-btn
              >
            </v-container>
          </v-flex>
        </v-layout>

        <br />
        <table
          class="table table-bordered"
          v-if="
            singleFacility.facility_type_id === 'Accomodation' &&
              singleFacility.accomodation_type_id === 'Pelican'
          "
        >
          <tr>
            <td>Type</td>
            <td>Lower Limit</td>
            <td>Upper Limit</td>
            <td>Amount</td>
            <td>Child Price</td>
          </tr>
          <tr v-for="(price, key) in facility.limit" :key="key">
            <td v-if="price.pricing_type === '9a9a77eb'">Self-catered</td>
            <td>{{ price.lower_limit }}</td>
            <td>{{ price.upper_limit }}</td>
            <td>{{ price.price }}</td>
            <td>{{ price.child_price }}</td>
          </tr>
          <tr v-for="(price, key) in facility.upper_limit" :key="key">
            <td v-if="price.pricing_type === '266677c3'">Fully Catered</td>
            <td>{{ price.lower_limit }}</td>
            <td>{{ price.upper_limit }}</td>
            <td>{{ price.price }}</td>
            <td>{{ price.child_price }}</td>
          </tr>
          <tr v-for="(price, key) in facility.middle_limit" :key="key">
            <td v-if="price.pricing_type === '377788d4'">
              Self-catered plus Chef
            </td>
            <td>{{ price.lower_limit }}</td>
            <td>{{ price.upper_limit }}</td>
            <td>{{ price.price }}</td>
            <td>{{ price.child_price }}</td>
          </tr>
        </table>

        <v-layout row wrap>
          <v-flex lg3 md3 sm12 xs12>
            <v-container fluid>
              <v-btn
                :depressed="true"
                color="primary"
                @click.prevent="postPricing()"
                >Add Price Schedule</v-btn
              >
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>

      <div
        class="row"
        v-if="
          singleFacility.facility_type_id ===
            'Ol Pejeta Escapes Accomodation' ||
            singleFacility.facility_type_id ===
              'Ol Pejeta Escapes Accommodation'
        "
      >
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
            <tr>
              <td>Start Date</td>
              <td>End Date</td>
              <td>Currency</td>
              <td>Adult Price</td>
              <td>Child Price</td>
              <td>Mandatory Price</td>
              <td>Lead Time</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, key) in facilityPricing" :key="key">
              <td>{{ formated_date(d.start_date) }}</td>
              <td>{{ formated_date(d.end_date) }}</td>
              <td>{{ d.currency_type }}</td>
              <td>{{ d.adult_price }}</td>
              <td>{{ d.child_price }}</td>
              <td>{{ d.mandatory_price }}</td>
              <td>{{ d.lead_time }} Days</td>

              <td>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  @click="deleteSchedule(d.public_id)"
                  >Disable</v-btn
                >
                <!-- <v-btn
                  :depressed="true"
                  color="success"
                  @click="showEditDialog(d)"
                  >Edit</v-btn
                > -->
                <v-dialog
                  v-model="edit_facility_dialog"
                  persistent
                  max-width="700px"
                >
                  <v-card>
                    <v-card-title>
                      <h4 class="earth-color">
                        EDIT PRICE SCHEDULE
                      </h4>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              slot="activator"
                              label="Start Date"
                              v-model="edit_facility.start_date"
                              :disabled="true"
                              readonly
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-menu
                              v-model="edit_facility.end_date_dialog"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template slot="activator">
                                <v-text-field
                                  v-model="edit_facility.end_date"
                                  label="End Date"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="edit_facility.end_date"
                                no-title
                                @input="edit_facility.end_date_dialog = false"
                                :min="edit_facility.start_date"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select
                              slot="activator"
                              label="Lead Time Format"
                              v-model="edit_facility.lead_time_format"
                              :items="formatArray"
                              :rules="[v => !!v || 'Item is required']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              slot="activator"
                              label="Lead Time"
                              v-model="edit_facility.lead_time"
                              :rules="requiredRules"
                              required
                              type="number"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select
                              label="Select Currency"
                              v-model="edit_facility.currency_type"
                              :items="allCurrencyTypes"
                              :rules="[v => !!v || 'Currency is required']"
                              required
                              item-text="currency_name"
                              item-value="currency_public_id"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              type="number"
                              label="Adult Price"
                              v-model="edit_facility.adult_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              type="number"
                              label="Child Price"
                              v-model="edit_facility.child_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              type="number"
                              label="Mandatory Price"
                              v-model="edit_facility.mandatory_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="red darken-1"
                        flat
                        @click="edit_facility_dialog = false"
                        >Close</v-btn
                      >
                      <v-btn color="green" flat @click="editPriceSchedule"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="row"
        v-if="singleFacility.facility_type_id === 'Camping Sites'"
      >
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
            <tr>
              <td>Start Date</td>
              <td>End Date</td>
              <td>Currency</td>
              <td>Adult Price</td>
              <td>Child Price</td>
              <td>Mandatory Price</td>
              <td>Lead Time</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, key) in facilityPricing" :key="key">
              <td>{{ formated_date(d.start_date) }}</td>
              <td>{{ formated_date(d.end_date) }}</td>
              <td>{{ d.currency_type }}</td>
              <td>{{ d.adult_price }}</td>
              <td>{{ d.child_price }}</td>
              <td>{{ d.mandatory_price }}</td>
              <td>{{ d.lead_time }} Days</td>
              <td>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  @click="deleteSchedule(d.public_id)"
                  >Disable</v-btn
                >
                <!-- <v-btn
                  :depressed="true"
                  color="success"
                  @click="showEditDialog(d)"
                  >Edit</v-btn
                > -->
                <v-dialog
                  v-model="edit_facility_dialog"
                  persistent
                  max-width="700px"
                >
                  <v-card>
                    <v-card-title>
                      <h4 class="earth-color">
                        EDIT PRICE SCHEDULE
                      </h4>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              slot="activator"
                              label="Start Date"
                              v-model="edit_facility.start_date"
                              :disabled="true"
                              readonly
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-menu
                              v-model="edit_facility.end_date_dialog"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template slot="activator">
                                <v-text-field
                                  v-model="edit_facility.end_date"
                                  label="End Date"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="edit_facility.end_date"
                                no-title
                                @input="edit_facility.end_date_dialog = false"
                                :min="edit_facility.start_date"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select
                              slot="activator"
                              label="Lead Time Format"
                              v-model="edit_facility.lead_time_format"
                              :items="formatArray"
                              :rules="[v => !!v || 'Item is required']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              slot="activator"
                              label="Lead Time"
                              v-model="edit_facility.lead_time"
                              :rules="requiredRules"
                              required
                              type="number"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select
                              label="Select Currency"
                              v-model="edit_facility.currency_type"
                              :items="allCurrencyTypes"
                              :rules="[v => !!v || 'Currency is required']"
                              required
                              item-text="currency_name"
                              item-value="currency_public_id"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              type="number"
                              label="Adult Price"
                              v-model="edit_facility.adult_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              type="number"
                              label="Child Price"
                              v-model="edit_facility.child_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              type="number"
                              label="Mandatory Price"
                              v-model="edit_facility.mandatory_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="red darken-1"
                        flat
                        @click="edit_facility_dialog = false"
                        >Close</v-btn
                      >
                      <v-btn color="green" flat @click="editPriceSchedule"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="row"
        v-if="singleFacility.facility_type_id === 'Accomodation'"
      >
        <div
          class="col-md-12"
          v-if="singleFacility.accomodation_type_id === 'Stables'"
        >
          <table cellpadding="1" cellspacing="1" class="table table-bordered">
            <thead>
              <tr>
                <td>Start Date</td>
                <td>End Date</td>
                <td>Currency</td>
                <td>Price</td>
                <td>Lead Time</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, key) in facilityPricing" :key="key">
                <td>{{ formated_date(d.start_date) }}</td>
                <td>{{ formated_date(d.end_date) }}</td>
                <td>{{ d.currency_type }}</td>
                <td>{{ d.mandatory_price }}</td>
                <td>{{ d.lead_time }} Days</td>
                <td>
                  <v-btn
                    :depressed="true"
                    color="error"
                    @click="deleteSchedule(d.public_id)"
                    >Disable</v-btn
                  >
                  <!-- <v-btn
                    :depressed="true"
                    color="success"
                    @click="showEditDialog(d)"
                    >Edit</v-btn
                  > -->
                  <v-dialog
                    v-model="edit_facility_dialog"
                    persistent
                    max-width="700px"
                  >
                    <v-card>
                      <v-card-title>
                        <h4 class="earth-color">
                          EDIT PRICE SCHEDULE
                        </h4>
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                slot="activator"
                                label="Start Date"
                                v-model="edit_facility.start_date"
                                :disabled="true"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-menu
                                v-model="edit_facility.end_date_dialog"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template slot="activator">
                                  <v-text-field
                                    v-model="edit_facility.end_date"
                                    label="End Date"
                                    hint="YYYY/MM/DD"
                                    persistent-hint
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="edit_facility.end_date"
                                  no-title
                                  @input="edit_facility.end_date_dialog = false"
                                  :min="edit_facility.start_date"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-select
                                slot="activator"
                                label="Lead Time Format"
                                v-model="edit_facility.lead_time_format"
                                :items="formatArray"
                                :rules="[v => !!v || 'Item is required']"
                                required
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                slot="activator"
                                label="Lead Time"
                                v-model="edit_facility.lead_time"
                                :rules="requiredRules"
                                required
                                type="number"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-select
                                label="Select Currency"
                                v-model="edit_facility.currency_type"
                                :items="allCurrencyTypes"
                                :rules="[v => !!v || 'Currency is required']"
                                required
                                item-text="currency_name"
                                item-value="currency_public_id"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                type="number"
                                label="Mandatory Price"
                                v-model="edit_facility.mandatory_price"
                                :rules="requiredRules"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          color="red darken-1"
                          flat
                          @click="edit_facility_dialog = false"
                          >Close</v-btn
                        >
                        <v-btn color="green" flat @click="editPriceSchedule"
                          >Update</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="col-md-12"
          v-if="singleFacility.accomodation_type_id === 'Pelican'"
        >
          <table cellpadding="1" cellspacing="1" class="table table-bordered">
            <thead>
              <tr>
                <td>Start Date</td>
                <td>End Date</td>
                <td>Self Catered Price</td>
                <td>Self Catered + Chef Price</td>
                <td>Fully Catered Price</td>
                <td>Lead Time</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, key) in normalPricing" :key="key">
                <td>{{ formated_date(d.start_date) }}</td>
                <td>{{ formated_date(d.end_date) }}</td>
                <td>
                  <small
                    v-for="(limit, key) in d.altered_limit_array"
                    :key="key"
                    >{{ limit.lower_limit }} - {{ limit.upper_limit }} =>
                    {{ d.lower_currency[key] }} {{ limit.price }} | Child -
                    {{ d.lower_currency[key] }} {{ limit.child_price }} <br
                  /></small>
                </td>
                <td>
                  <small
                    v-for="(limit, key) in d.altered_middle_limit_array"
                    :key="key"
                    >{{ limit.lower_limit }} - {{ limit.upper_limit }} =>
                    {{ d.middle_currency[key] }} {{ limit.price }} | Child -
                    {{ d.middle_currency[key] }} {{ limit.child_price }} <br
                  /></small>
                </td>
                <td>
                  <small
                    v-for="(limit, key) in d.altered_upper_limit_array"
                    :key="key"
                    >{{ limit.lower_limit }} - {{ limit.upper_limit }} =>
                    {{ d.upper_currency[key] }} {{ limit.price }} | Child -
                    {{ d.upper_currency[key] }} {{ limit.child_price }} <br
                  /></small>
                </td>
                <td>{{ d.lead_time }} Days</td>
                <td>
                  <v-btn
                    :depressed="true"
                    color="error"
                    @click="deleteSchedule(d.public_id)"
                    >Disable</v-btn
                  >
                  <!-- <v-btn
                    :depressed="true"
                    color="success"
                    @click="showEditDialog1(d)"
                    >Edit</v-btn
                  > -->
                  <v-dialog
                    v-model="edit_facility_dialog1"
                    persistent
                    max-width="700px"
                  >
                    <v-card>
                      <v-card-title>
                        <h4 class="earth-color">
                          EDIT PRICE SCHEDULE
                        </h4>
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                slot="activator"
                                label="Start Date"
                                v-model="edit_facility.start_date"
                                :disabled="true"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-menu
                                v-model="edit_facility.end_date_dialog"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template slot="activator">
                                  <v-text-field
                                    v-model="edit_facility.end_date"
                                    label="End Date"
                                    hint="YYYY/MM/DD"
                                    persistent-hint
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="edit_facility.end_date"
                                  no-title
                                  @input="edit_facility.end_date_dialog = false"
                                  :min="edit_facility.start_date"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-select
                                slot="activator"
                                label="Lead Time Format"
                                v-model="edit_facility.lead_time_format"
                                :items="formatArray"
                                :rules="[v => !!v || 'Item is required']"
                                required
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-text-field
                                slot="activator"
                                label="Lead Time"
                                v-model="edit_facility.lead_time"
                                :rules="requiredRules"
                                required
                                type="number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          color="red darken-1"
                          flat
                          @click="edit_facility_dialog1 = false"
                          >Close</v-btn
                        >
                        <v-btn color="green" flat @click="editPriceSchedule"
                          >Update</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="row"
        v-if="singleFacility.facility_type_id === 'External Accommodation'"
      >
        <table cellpadding="1" cellspacing="1" class="table table-bordered">
          <thead>
            <tr>
              <td>Start Date</td>
              <td>End Date</td>
              <td>Parameter Name</td>
              <td>Currency</td>
              <td>Mandatory Price</td>
              <td>Lead Time</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, key) in facilityPricing" :key="key">
              <td>{{ formated_date(d.start_date) }}</td>
              <td>{{ formated_date(d.end_date) }}</td>
              <td>{{ d.facility_parameter_name }}</td>
              <td>{{ d.currency_type }}</td>
              
              <td>
                {{ d.mandatory_price }}
              </td>
              <td>{{ d.lead_time }} Days</td>
              <td>
                <v-btn
                  :depressed="true"
                  color="error"
                  small
                  @click="deleteSchedule(d.public_id)"
                  >Disable</v-btn
                >
                <!-- <v-btn
                  :depressed="true"
                  color="success"
                  @click="showEditDialog(d)"
                  >Edit</v-btn
                > -->
                <v-dialog
                  v-model="edit_facility_dialog"
                  persistent
                  max-width="700px"
                >
                  <v-card>
                    <v-card-title>
                      <h4 class="earth-color">
                        EDIT PRICE SCHEDULE
                      </h4>
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              slot="activator"
                              label="Start Date"
                              v-model="edit_facility.start_date"
                              :disabled="true"
                              readonly
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-menu
                              v-model="edit_facility.end_date_dialog"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template slot="activator">
                                <v-text-field
                                  v-model="edit_facility.end_date"
                                  label="End Date"
                                  hint="YYYY/MM/DD"
                                  persistent-hint
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="edit_facility.end_date"
                                no-title
                                @input="edit_facility.end_date_dialog = false"
                                :min="edit_facility.start_date"
                              ></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select
                              slot="activator"
                              label="Lead Time Format"
                              v-model="edit_facility.lead_time_format"
                              :items="formatArray"
                              :rules="[v => !!v || 'Item is required']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              slot="activator"
                              label="Lead Time"
                              v-model="edit_facility.lead_time"
                              :rules="requiredRules"
                              required
                              type="number"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-select
                              label="Select Currency"
                              v-model="edit_facility.currency_type"
                              :items="allCurrencyTypes"
                              :rules="[v => !!v || 'Currency is required']"
                              required
                              item-text="currency_name"
                              item-value="currency_public_id"
                            ></v-select>
                          </v-flex>
                          <v-flex lg6 md6 sm12 xs12>
                            <v-autocomplete
                              label="Select Parameter"
                              v-model="edit_facility.facility_parameter_id"
                              :items="facilityPricingParameter"
                              :rules="[
                                v => !!v || 'Pricing parameter is required'
                              ]"
                              required
                              item-text="facility_parameter_name"
                              item-value="public_id"
                              @change="getEditRate"
                              :loading="$loadingTrue"
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex lg3 md3 sm3 xs3>
                            <v-text-field
                              type="number"
                              label="Amount"
                              v-model="edit_facility.mandatory_price"
                              :rules="requiredRules"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg9 md9 sm9 xs9>
                            <h5 style="margin-top:25px">{{ rateValue }}</h5>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="red darken-1"
                        flat
                        @click="edit_facility_dialog = false"
                        >Close</v-btn
                      >
                      <v-btn color="green" flat @click="editPriceSchedule"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import DateVuex from "../../../mixins/Functions/DateMixins";
import CurencyVuex from "../../../mixins/Computed/Finance/CurrencyVuex";
import FacilityVuex from "../../../mixins/Computed/Facility/FacilityVuex";
export default {
  name: "facility-pricing",
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],
      today: this.$moment().format("YYYY-MM-DD"),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,

      edit_facility_dialog: false,
      edit_facility_dialog1: false,
      rate: "",

      facility: {
        public_id: this.$route.params.facility_id,
        type: "",
        start_date: "",
        end_date: "",
        child_price: "",
        adult_price: "",
        currency_type: "",
        mandatory_price: "",
        limit: [],
        upper_limit: [],
        middle_limit: [],
        facility_id: this.$route.params.facility_id,
        lead_time_format: "Days",
        lead_time: 0,
        facility_parameter_id: "",
        session_id: localStorage.getItem("lkjhgfdsa")
      },
      edit_facility: {
        price_id: "",
        public_id: this.$route.params.facility_id,
        type: "",
        start_date: "",
        end_date: "",
        child_price: "",
        adult_price: "",
        currency_type: "",
        mandatory_price: "",
        limit: [],
        upper_limit: [],
        middle_limit: [],
        facility_id: this.$route.params.facility_id,
        lead_time_format: "Days",
        lead_time: 0,
        start_date_dialog: false,
        end_date_dialog: false,
        facility_parameter_id: "",
        session_id: localStorage.getItem("lkjhgfdsa")
      },
      group: {
        currency_type: "",
        price_from: "",
        price_to: "",
        price: "",
        pricing_type: "",
        child_price: ""
      },
      edit_group: {
        currency_type: "",
        price_from: "",
        price_to: "",
        price: "",
        pricing_type: "",
        child_price: ""
      }
    };
  },
  created() {
    this.$store.dispatch("get_facility", this.$route.params.facility_id);
    this.$store.dispatch(
      "get_facility_pricing",
      this.$route.params.facility_id
    );
    this.$store.dispatch(
      "get_priced_facility_parameter",
      this.$route.params.facility_id
    );
    this.$store.dispatch(
      "get_facility_pricing_parameter",
      this.$route.params.facility_id
    );
    this.$store.dispatch("get_all_currency_types");
    this.$store.dispatch("get_all_facility_pricing_types");
  },
  computed: {
    formatArray() {
      let slots = [];
      var myStringArray = ["Days", "Hours", "Minutes"];
      var arrayLength = myStringArray.length;
      for (var i = 0; i < arrayLength; i++) {
        slots.push(myStringArray[i]);
      }
      return slots;
    },
    cateringType() {
      var normalPricing = [];
      var length = this.$allPricingGroups.length;
      for (var i = 0; i < length; i++) {
        if (i < 3) {
          normalPricing.push(this.$allPricingGroups[i]);
        }
      }
      return normalPricing;
    },
    normalPricing() {
      var normalPricing = [];
      this.facilityPricing.map(function(data) {
        if (data.group === "None") {
          normalPricing.push(data);
        }
      });
      return normalPricing;
    },
    rateValue() {
      return this.rate;
    }
  },
  methods: {
    facilityType: function() {
      if (
        this.singleFacility.facility_type_id === "Accomodation" &&
        this.singleFacility.accomodation_type_id === "Pelican"
      ) {
        return "pelican";
      } else if (
        this.singleFacility.facility_type_id === "Accomodation" &&
        this.singleFacility.accomodation_type_id === "Stables"
      ) {
        return "stables";
      } else if (
        this.singleFacility.facility_type_id === "External Accommodation"
      ) {
        return "external_accommodation";
      } else {
        return "camping";
      }
    },
    addGroup: function() {
      var data = {
        currency: this.group.currency_type,
        lower_limit: this.group.price_from,
        upper_limit: this.group.price_to,
        middle_limit: this.group.price_to,
        price: this.group.price,
        child_price: this.group.child_price,
        pricing_type: this.group.pricing_type
      };
      
      // This is for Self Catered
      if (this.group.pricing_type === "9a9a77eb") {
        this.facility.limit.push(data);
      } else if (this.group.pricing_type === "377788d4") {
        // This is for Self + Chef Catered
        this.facility.middle_limit.push(data);
      } else {
        this.facility.upper_limit.push(data);
      }
    //   this.group.currency_type = "";
    //   this.group.price_from = "";
    //   this.group.price_to = "";
    //   this.group.price = "";
    //   this.group.child_price = "";
    //   this.group.pricing_type = "";
    },
    putStartDate: function() {
      var date = this.facility.start_date;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.facility.start_date = date;
    },
    putEndtDate: function() {
      var date = this.facility.end_date;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.facility.end_date = date;
    },
    showEditDialog(price) {
      this.edit_facility_dialog = true;
      this.edit_facility.price_id = price.facility_unavailability_public_id;
      this.edit_facility.start_date = this.$moment(price.start_date).format(
        "YYYY-MM-DD"
      );
      this.edit_facility.end_date = this.$moment(price.end_date).format(
        "YYYY-MM-DD"
      );
      this.edit_facility.lead_time_format = price.lead_time_format;
      this.edit_facility.lead_time = price.lead_time;
      this.edit_facility.mandatory_price = price.mandatory_price;
      this.edit_facility.currency_type = price.currency_type;
      this.edit_facility.adult_price = price.adult_price;
      this.edit_facility.child_price = price.child_price;
      this.edit_facility.public_id = price.public_id;
    },
    showEditDialog1(price) {
      this.edit_facility_dialog1 = true;
      this.edit_facility.price_id = price.facility_unavailability_public_id;
      this.edit_facility.start_date = this.$moment(price.start_date).format(
        "YYYY-MM-DD"
      );
      this.edit_facility.end_date = this.$moment(price.end_date).format(
        "YYYY-MM-DD"
      );
      this.edit_facility.lead_time_format = price.lead_time_format;
      this.edit_facility.public_id = price.public_id;
    },
    makeActive: function(publicId) {
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id
      };
      this.$store.dispatch("make_facility_pricing_active", data);
    },
    deleteSchedule: function(publicId) {
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id,
        deleted_by: localStorage.getItem("lkjhgfdsa")
      };
      this.$store.dispatch("delete_facility_pricing", data);
    },
    postPricing: function() {
      this.facility.type = this.facilityType();
      this.$store.dispatch("post_facility_pricing", this.facility)
        
    },

    editPriceSchedule() {
      this.edit_facility_dialog = false;
      this.edit_facility_dialog1 = false;
      this.edit_facility.type = this.facilityType();

      this.$store.dispatch("update_facility_pricing", this.edit_facility);
    },
    getRate() {
    
      // let facAllocation = this.this.$store.state.FacilityStore.facilities[index].allocation.name;
      let facParameter = this.facility.facility_parameter_id;

      let allParameters = this.facilityPricingParameter;
      let parNameArr = allParameters.filter(
        parameter => parameter.public_id === facParameter
      );
      let parName = parNameArr[0].facility_parameter_name;
      this.rate = `${facAllocation}/ per ${parName}`;
    },
    getEditRate() {
      let facAllocation = this.singleFacility.allocation.name;
      let facParameter = this.edit_facility.facility_parameter_id;
      let allParameters = this.facilityPricingParameter;
      let parNameArr = allParameters.filter(
        parameter => parameter.public_id === facParameter
      );
      let parName = parNameArr[0].facility_parameter_name;
      this.rate = `${facAllocation}/ per ${parName}`;
    }
  },
  components: {
    Datepicker
  },
  mixins: [CurencyVuex, FacilityVuex, DateVuex]
};
</script>

<style scoped></style>
